var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"usage-terms-create"},[(_vm.usageTerm)?_c('usage-terms-form',{attrs:{"item":_vm.usageTerm,"admin":_vm.isAdminUsageTerms}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }